import React from 'react'
import 'NotFoundPage.sass'

const NotFoundPage: React.FC = () => (
  <div className="page-not-found">
    <h1>404 - Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </div>
)

export default NotFoundPage
